import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
export const config = {
    value: 'filterSearch',
    position: ALL_BUTTON_POSITION_LIST,
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options = {} } = buttonConfig;
        const { _bindFilter } = options;
        function searchOneFilter(id) {
            if (typeof id === 'string') {
                const filter = _context.$(id);
                filter?.search?.();
            }
        }
        if (_bindFilter && _context) {
            if (Array.isArray(_bindFilter)) {
                _bindFilter.forEach((item) => {
                    searchOneFilter(item);
                });
            }
            else {
                searchOneFilter(_bindFilter);
            }
        }
    },
};
